import cx from 'classnames';
import i18next from 'i18next';

import { updateSideSelection } from 'actions/placeorder';
import { SIDE } from 'constants/enums';
import { isEmpty } from 'helpers/utils';
import { l2BestAsksSelector } from 'selectors/l2OrderbookSelector';
import {
  enabledPortfolioAssetsSelector,
  userMarginModeSelector,
} from 'selectors/otherSelectors';
import { orderSubmitStatusSelector } from 'selectors/placeOrderSelector';
import { selectedProductSelector } from 'selectors/tradeSelectors';
import { useAppDispatch, useAppSelector } from 'storeHooks';

import { EnabledPFs, getWarningMessage } from '../MarginTypeWarning/util';
import styles from './ChartScreen.module.scss';

const longLabel = i18next.t('trading:long');

const BestAsk = () => {
  const bestAsk = useAppSelector(l2BestAsksSelector);
  return <div data-palette="BestAsk">{bestAsk}</div>;
};

const BuyButton = ({ disabled }: { disabled: boolean }) => {
  const dispatch = useAppDispatch();
  const orderSubmitStatus = useAppSelector(orderSubmitStatusSelector);
  const userMarginMode = useAppSelector(userMarginModeSelector);
  const selectedProduct = useAppSelector(selectedProductSelector);
  const enabledPfs = useAppSelector(enabledPortfolioAssetsSelector) as EnabledPFs;

  const warningMsg = getWarningMessage({
    marginMode: userMarginMode as string,
    selectedProduct: selectedProduct || {},
    enabledPfs,
  });

  const handleClick = () => {
    dispatch(updateSideSelection(SIDE.BUY));
  };

  return (
    (<button
      type="submit"
      data-testid="chart-long-button"
      className={cx('naked btn', styles.buyButton, styles.buttonsCommonStyles)}
      onClick={handleClick}
      disabled={disabled || orderSubmitStatus === 'loading' || !isEmpty(warningMsg)}
      data-palette="BuyButton">
      <div>{longLabel}</div>
      <BestAsk />
    </button>)
  );
};

export default BuyButton;
